// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3czAE","topBottomGutter":"Layout_topBottomGutter__lMyz6"};